{
  "footer": {
    "alreadyPartner": "Oled juba partner?",
    "back": "Tagasi",
    "letsgo": "Läksime",
    "login": "Logi sisse",
    "next": "Edasi",
    "readMore": "Uuri lähemalt",
    "signUp": "Loo kasutaja"
  },
  "formErrors": {
    "address": "Seda aadressi ei leitud. Palun sisesta olemasolev aadress",
    "businessName": "See nimi ei ole saadaval. Palun vali teine nimi",
    "email": "Seda meiliaadressi on juba kasutatud",
    "verificationCode": "Vigane kood"
  },
  "global": {
    "title": "Liitu Treatwelliga"
  },
  "input": {
    "businessName": {
      "invalid": "Ettevõtte nimi on liiga pikk",
      "label": "Ettevõtte nimi",
      "required": "Kohustuslik väli"
    },
    "businessSegment": {
      "aesthetics": "Iluprotseduurid",
      "barber": "Juuksur",
      "beautician": "Kosmeetik",
      "hair-removal": "Karvaeemaldus",
      "hairdresser": "Juuksur",
      "massage": "Massaaž",
      "nails": "Küüned",
      "primary": "Põhiteenus",
      "required": "Vali vähemalt üks",
      "spa": "Spa"
    },
    "businessType": {
      "dedicatedSpaceCheckbox": "Kinnitan, et mul on ettevõtte tegevuseks olemas vajalikud ruumid",
      "home": "Kodusalong <0>- sinu kliendid võivad tulla sulle koju</0>",
      "mobile": "Mobiilne <0>- sa lähed klientide koju</0>",
      "mobileCheckbox": "Ma soovin Treatwelli kasutada AINULT broneerimistarkvarana ja MITTE marketplace-ina.",
      "mobileMessage": "Piirangute tõttu on võimalik marketplace-is kuvada vaid fikseeritud aadressiga ettevõtteid.",
      "required": "Vali üks",
      "shop": "Pood <0>- sinu kliendid tulevad poodi</0>"
    },
    "city": {
      "invalid": "Linn on liiga pikk",
      "label": "Linn",
      "required": "Kohustuslik väli"
    },
    "country": {
      "label": "Riik",
      "required": "Kohustuslik väli"
    },
    "email": {
      "invalid": "Vigane meiliaadress",
      "label": "Meiliaadress",
      "required": "Kohustuslik väli"
    },
    "firstName": {
      "invalid": "Ära kasuta sümboleid",
      "label": "Eesnimi",
      "required": "Kohustuslik väli"
    },
    "lastName": {
      "invalid": "Ära kasuta sümboleid",
      "label": "Perekonnanimi",
      "required": "Kohustuslik väli"
    },
    "marketing": {
      "label": "Soovin saada meili teel ekspertide nõuandeid oma äri kasvatamise kohta."
    },
    "password": {
      "hint": "Minimaalselt 8 tähemärki",
      "invalid": "Salasõna peab olema minimaalselt 8 tähemärki",
      "label": "Salasõna",
      "required": "Kohustuslik väli"
    },
    "phoneNumber": {
      "invalid": "Telefonumber on vigane",
      "label": "Telefoninumber",
      "required": "Kohustuslik väli"
    },
    "postalCode": {
      "invalid": "Postiindeks on liiga pikk",
      "label": "Postiindeks",
      "required": "Kohustuslik väli"
    },
    "privacy": {
      "label": "Freemium konto loomisel nõustud meie <0>Privaatsuspoliitika</0> ja <1>Tingimustega</1>"
    },
    "searchBusiness": {
      "label": "Otsi ettevõtet"
    },
    "street": {
      "invalid": "Aadress on liiga pikk",
      "label": "Aadress",
      "required": "Kohustuslik väli"
    }
  },
  "salesMode": {
    "enterPassword": "Sisesta salasõna müügirežiimi jaoks",
    "invalidPassword": "Vale salasõna"
  },
  "stepContext": {
    "attractNewClients": "Äratada uute klientide tähelepanu",
    "buildRelationships": "Luua oma klientidega veel parem suhtlus",
    "growBusiness": "Kasvatada oma ettevõttet muretult",
    "manageAppointments": "Hallata kõiki broneeringuid ükskõik kus ükskõik millal",
    "prompt": "Sa oled vaid mõne lihtsa sammu (ja umbes 3 minuti) kaugusel liitumisest 75 000 salongiga, et hallata oma ettevõtlust, kasvatada kliendibaasi ja müügitulu.<br /><br />Treatwelliga saad sa:",
    "prompt2": "...ja palju muud.",
    "title": "<0>Treatwelli</0> - Euroopa suurima iluteenuste pakkujate platvormiga liitumine ei ole kunagi olnud lihtsam."
  },
  "stepCounter": {
    "step0": "Samm 1",
    "step1": "Samm 1",
    "step2": "Samm 2",
    "step3": "Samm 3",
    "step4": "Samm 4",
    "step5": "Palju õnne"
  },
  "stepEmailVerification": {
    "resend": "Saada uuesti",
    "subTitle1": "Registreerimise lõpule viimiseks lihtsalt sisesta kood.",
    "subTitle2": "Ei saanud koodi?",
    "title": "<0>Peaaegu valmis,</0> saatsime sulle 6-kohalise koodi meili teel!"
  },
  "stepError": {
    "accountCreation": "konto loomine",
    "body": "Ilmnesid tõrked.\nPalun oota veidi ja proovi uuesti.",
    "bodyWithError": "Ilmnesid tõrked {{reason}}.\nPalun oota veidi ja proovi uuesti.",
    "button": "Proovi uuesti",
    "title": "Oih, midagi läks valesti!"
  },
  "stepFinal": {
    "joke1Punchline": "Šampuudel!",
    "joke1Setup": "Milline koer on juuksuril?",
    "joke2Punchline": "Lõigates!",
    "joke2Setup": "Kuidas võitis juuksur jooksuvõistluse?",
    "joke3Punchline": "Barbe-cue!",
    "joke3Setup": "Kuidas sa kutsud soengut ootavat meeste rivi?",
    "joke4Punchline": "Eclipse-ides!",
    "joke4Setup": "Kuidas lõikab juukseid mees Kuul?",
    "joke5Punchline": "stepFinal.joke5Punchline",
    "joke5Setup": "stepFinal.joke5Setup",
    "subTitle": "Kui ootad, siis lõbusalt",
    "title": "Täname, seadistame nüüd sinu ettevõtte!<br />Anna meile <0>2 minutit...</0>"
  },
  "stepFinalRedirectLogin": {
    "alternativeButton": "Loo kasutaja",
    "alternativeMessage": "Kas sa kasutad sama asukohta uue ettevõtte lisamiseks?",
    "button": "Treatwell sisselogimine",
    "message": "<0>Head uudised!</0> Sinu ettevõte on juba Treatwellis seadistatud."
  },
  "stepFourForm": {
    "prompt1": "Me kasutame seda informatsiooni sinu konto loomiseks ja vajadusel võtame ühendust",
    "title": "Räägi meile endast"
  },
  "stepOneForm": {
    "prompt1": "Otsi või sisesta oma ettevõtte nimi",
    "title": "Räägi meile oma ettevõttest"
  },
  "stepOneSearch": {
    "addManually": "Ei leia oma ettevõtet? <0>Lisa see käsitsi</0>",
    "prompt1": "Sisesta oma ettevõtte nimi",
    "title": "Räägi meile oma ettevõttest"
  },
  "stepThreeForm": {
    "title": "Mis tüüpi ettevõte sul on?"
  },
  "stepTwoForm": {
    "prompt1": "Vali kõik sobivad, aga põhiteenus esimesena",
    "title": "Milliseid teenuseid sa pakud?"
  }
}